import React, { useEffect, useState } from "react";
import { CloseButton, Modal } from "react-bootstrap";
import { Button } from "antd";
import { useComponentStore } from "./store";

function ModalCompView({ modalShow, setModalShow, contentKey, type }) {
  const { viewData, viewLoading, fetchView } = useComponentStore();
  const [modalData, setModalData] = useState([]);

  useEffect(() => {
    if (type && contentKey) {
      fetchView(contentKey, type);
    }
  }, [contentKey, type]);

  useEffect(() => {
    const viewLength =
      type === "segments"
        ? viewData?.data?.length
        : viewData?.data?.contents?.length;
    if (viewLength) {
      const modalData = viewData?.data;
      if (type === "segments") {
        const segArray = [];
        for (const data of modalData) {
          segArray.push(data?.segment[0]?.display_name);
        }
        const details = segArray?.map((text, index) => {
          return {
            index: index + 1,
            text: text,
          };
        });
        setModalData(details);
      } else {
        if (modalData) {
          const modalData = viewData?.data;
          const segArray = (modalData?.contents || [])?.map(
            (contentData) => contentData?.displayName
          );
          const details = segArray.map((text, index) => {
            return {
              index: index + 1,
              text: text,
            };
          });
          setModalData(details);
        }
      }
    } else {
      setModalData([]);
    }
  }, [viewData]);

  return (
    <div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {type === "segments" ? "Segment" : "Content"}
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setModalShow(false)}
          />
        </Modal.Header>
        <Modal.Body
          className="scrollable-container"
          style={{ maxHeight: "82vh", overflowY: "scroll" }}
        >
          {modalData?.map((item, index) => (
            <div key={index} style={{ marginBottom: "10px" }}>
              <div className="fw-bold">{`${item.index}. ${item.text}`}</div>
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ModalCompView;
